import {useTranslation} from '@aboutyou/i18n';
import {
  Button,
  COLORS,
  FONT_SIZES,
  GenericIconName,
  Icon,
  tabFocusedStyles,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {useIsAuthenticated} from '../../features/Authentication/hooks/useIsAuthenticated';
import {LanguageCountrySwitch} from '../LanguageCountrySwitch/LanguageCountrySwitch';
import {SelectedLanguageLabel} from '../LanguageCountrySwitch/components/LanguageCountrySwitch';

interface OffcanvasActionsProps {
  onLogoutClick: VoidFunction;
}

export const OffcanvasActions: FC<OffcanvasActionsProps> = ({
  onLogoutClick,
}) => {
  const {t} = useTranslation();
  const {isAuthenticated} = useIsAuthenticated();

  return (
    <ActionContainer data-testid="ActionContainer">
      <StyledLanguageCountrySwitch openAs="flyout" />
      {isAuthenticated && (
        <LogoutButton
          onClick={onLogoutClick}
          aria-label={undefined}
          variant="secondary"
        >
          <Icon asset={GenericIconName.NavUser} fill={COLORS.Black} size="XS" />
          <StyledLabel data-testid="offCanvasLogout">{t('Logout')}</StyledLabel>
        </LogoutButton>
      )}
    </ActionContainer>
  );
};

const StyledLanguageCountrySwitch = styled(LanguageCountrySwitch)`
  &&& {
    padding: 12px 13px;
    background-color: ${COLORS.White};
    border: 1px solid ${COLORS.Grey3};
    border-radius: 3px;
    ${SelectedLanguageLabel} {
      color: ${COLORS.Grey1};
      border: 1px solid ${COLORS.Grey3};
    }

    &:focus-visible {
      ${tabFocusedStyles()}
    }
  }
`;

const LogoutButton = styled(Button)`
  font-size: ${FONT_SIZES.px12};
  height: 40px;
  padding: 10px 16px;
`;

const ActionContainer = styled.div`
  display: flex;
  gap: 4px;
  justify-content: space-between;
  padding: 32px 20px 12px 20px;
  border-top: 1px solid ${COLORS.Grey3};
  margin: 0 -20px;
`;

const StyledLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 4px;
`;
